import { FieldDesignTable } from "~/components/Document/tables";
import type { Document as AppDocument } from "~/interface/document";

interface HistoryFieldDesignProps {
  formData: AppDocument[];
}

const HistoryFieldDesign = ({ formData }: HistoryFieldDesignProps) => {
  return <FieldDesignTable formData={formData} mode="full" />;
};

export default HistoryFieldDesign;
